export default __webpack_public_path__ + "static/media/access-two-true.b4b02cab.svg";